<section
  id="marketplace"
  class="relative overflow-hidden py-24 px-6 lg:px-12"
  style="background: var(--theme-bg)"
  aria-label="Freight Marketplace"
  *transloco="let t"
>
  <div class="dot-accent-tr" aria-hidden="true"></div>

  <div class="max-w-7xl mx-auto">
    <!-- Heading -->
    <div class="max-w-2xl mb-16">
      <div class="section-label reveal">{{ t('marketplace.label') }}</div>
      <h2
        class="font-display font-bold mb-4 reveal stagger-1"
        style="font-size:clamp(1.875rem,4vw,3.125rem);letter-spacing:-0.025em;line-height:1.1"
      >
        {{ t('marketplace.headline') }}<br />
        <span class="gradient-text">{{ t('marketplace.headlineSub') }}</span>
      </h2>
      <p class="text-lg reveal stagger-2" style="color:var(--theme-text-dim);line-height:1.8">
        {{ t('marketplace.desc') }}
      </p>
    </div>

    <!-- Shipper / Carrier cards -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12">

      <!-- Shippers -->
      <div class="glow-card glass rounded-3xl p-8 lg:p-10 reveal stagger-2" style="border-color:rgba(0,140,240,0.18)">
        <div class="shimmer-stripe"></div>
        <div
          class="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest mb-6"
          style="background:rgba(0,140,240,0.15);color:#008CF0;border:1px solid rgba(0,140,240,0.3)"
        >
          {{ t('marketplace.shippers.badge') }}
        </div>
        <h3 class="font-display font-bold text-xl mb-2" style="color:var(--theme-text)">
          {{ t('marketplace.shippers.title') }}
        </h3>
        <p class="text-sm mb-8" style="color:var(--theme-text-dim)">{{ t('marketplace.shippers.subtitle') }}</p>

        <ol class="space-y-5">
          @for (step of shipperSteps; track step.num) {
            <li class="flex items-start gap-4">
              <span
                class="shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold"
                style="background:rgba(0,140,240,0.18);color:#008CF0;border:1px solid rgba(0,140,240,0.35)"
              >{{ step.num }}</span>
              <div>
                <p class="font-semibold text-sm mb-0.5" style="color:var(--theme-text)">{{ t(step.title) }}</p>
                <p class="text-xs leading-relaxed" style="color:var(--theme-text-dim)">{{ t(step.desc) }}</p>
              </div>
            </li>
          }
        </ol>

        <a
          [href]="freightLoginUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-primary mt-8 inline-flex text-sm"
        >
          {{ t('marketplace.shippers.cta') }}
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M7 17L17 7M17 7H7M17 7v10" />
          </svg>
        </a>
      </div>

      <!-- Carriers -->
      <div class="glow-card glass rounded-3xl p-8 lg:p-10 reveal stagger-3" style="border-color:rgba(0,212,255,0.15)">
        <div class="shimmer-stripe"></div>
        <div
          class="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest mb-6"
          style="background:rgba(0,212,255,0.12);color:#00D4FF;border:1px solid rgba(0,212,255,0.3)"
        >
          {{ t('marketplace.carriers.badge') }}
        </div>
        <h3 class="font-display font-bold text-xl mb-2" style="color:var(--theme-text)">
          {{ t('marketplace.carriers.title') }}
        </h3>
        <p class="text-sm mb-8" style="color:var(--theme-text-dim)">{{ t('marketplace.carriers.subtitle') }}</p>

        <ol class="space-y-5">
          @for (step of carrierSteps; track step.num) {
            <li class="flex items-start gap-4">
              <span
                class="shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold"
                style="background:rgba(0,212,255,0.14);color:#00D4FF;border:1px solid rgba(0,212,255,0.35)"
              >{{ step.num }}</span>
              <div>
                <p class="font-semibold text-sm mb-0.5" style="color:var(--theme-text)">{{ t(step.title) }}</p>
                <p class="text-xs leading-relaxed" style="color:var(--theme-text-dim)">{{ t(step.desc) }}</p>
              </div>
            </li>
          }
        </ol>

        <a
          [href]="fleetLoginUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="btn-secondary mt-8 inline-flex text-sm"
        >
          {{ t('marketplace.carriers.cta') }}
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>

    <!-- Capability pills -->
    <div class="flex flex-wrap gap-3 reveal stagger-4">
      @for (cap of marketplaceCaps; track cap) {
        <div
          class="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium glass"
          style="color:var(--theme-text-dim);border-color:rgba(255,255,255,0.07)"
        >
          <span class="w-1.5 h-1.5 rounded-full shrink-0" style="background:#008CF0"></span>
          {{ cap }}
        </div>
      }
    </div>
  </div>
</section>
